import { sva } from "@stubhub/broadway-foundation/css";

const seoTableSlots = ["wrapper", "headingWrapper", "table", "headerCell", "row", "cell", "caption"] as const;

export const seoTableRecipe = sva({
  slots: seoTableSlots,
  className: "seoTable",
  base: {
    // vertical rhythm is owned by the parent layout
    wrapper: {},
    headingWrapper: {
      marginBlockEnd: "primitives.150",
    },
    table: {
      width: "full",
      borderCollapse: "collapse",
      tablet: {
        tableLayout: "fixed",
      },
    },
    headerCell: {
      paddingBlockStart: "primitives.200",
      paddingBlockEnd: "primitives.200",
      paddingInlineStart: "primitives.200",
      paddingInlineEnd: "primitives.200",
      textAlign: "start",
      color: "text.subtle",
      borderBlockEndWidth: "primitives.25",
      borderBlockEndStyle: "solid",
      borderBlockEndColor: "border",
      tablet: {
        paddingInlineStart: "primitives.300",
        paddingInlineEnd: "primitives.300",
      },
    },
    row: {
      borderBlockEndWidth: "primitives.25",
      borderBlockEndStyle: "solid",
      borderBlockEndColor: "border",
    },
    cell: {
      paddingBlockStart: "primitives.200",
      paddingBlockEnd: "primitives.200",
      paddingInlineStart: "primitives.200",
      paddingInlineEnd: "primitives.200",
      textAlign: "start",
      verticalAlign: "middle",
      color: "text",
      tablet: {
        paddingInlineStart: "primitives.300",
        paddingInlineEnd: "primitives.300",
      },
    },
    caption: {
      position: "absolute",
      width: "[1px]",
      height: "[1px]",
      paddingBlockStart: "primitives.0",
      paddingInlineEnd: "primitives.0",
      paddingBlockEnd: "primitives.0",
      paddingInlineStart: "primitives.0",
      marginBlockStart: "[-1px]",
      marginInlineEnd: "[-1px]",
      marginBlockEnd: "[-1px]",
      marginInlineStart: "[-1px]",
      overflowX: "hidden",
      overflowY: "hidden",
      clip: "[rect(0,0,0,0)]",
      whiteSpace: "nowrap",
      borderBlockStartWidth: "primitives.0",
      borderInlineEndWidth: "primitives.0",
      borderBlockEndWidth: "primitives.0",
      borderInlineStartWidth: "primitives.0",
    },
  },
});
